import { ApiErrorContent } from '../model/Error'
import { Mail } from '../model/Mail'
import { formatFr } from './date.utilities'

export const subCodeTokenExpired = (data: ApiErrorContent, status: number | undefined) => {
  try {
    return status === 400 && data?.detail && JSON.parse(data.detail).statusCode === 401
  } catch (e) {
    return false
  }
}

/**
 * AIA Keycloak renvoyée par l'API quand le token PSC est absent / expiré.
 * Axios normalise les headers en minuscules ; certains proxies transforment
 * l'underscore en tiret. Le body (`detail` / `description`) duplique kc_action
 * si les headers sont filtrés.
 */
export const getPscReconnectAction = (
  headers?: unknown,
  ...details: Array<string | undefined>
): string | null => {
  const fromValue = (raw: unknown): string | null =>
    typeof raw === 'string' && raw.startsWith('idp_link:') ? raw : null

  if (headers && typeof headers === 'object') {
    const record = headers as Record<string, unknown> & { get?: (name: string) => unknown }
    const fromGetter =
      typeof record.get === 'function'
        ? record.get('kc_action') ?? record.get('kc-action')
        : undefined
    const fromHeaders = fromValue(fromGetter ?? record.kc_action ?? record['kc-action'])
    if (fromHeaders) {
      return fromHeaders
    }
  }

  for (const detail of details) {
    if (!detail) {
      continue
    }
    try {
      const fromDetail = fromValue(JSON.parse(detail)?.kc_action)
      if (fromDetail) {
        return fromDetail
      }
    } catch {
      // detail n'est pas du JSON (ex. "Bad Request")
    }
  }

  return null
}

export const formatMailReply = (mail: Mail) =>
  `<p>
<p>___________________________________________</p>
<p>De: ${mail.nameFrom} &lt;${mail.emailFrom}&gt;</p>
<p>À: "&lt;${mail.emailTo}&gt;"</p>
<p>Envoyé: ${mail?.date?.date ? formatFr(new Date(mail.date.date), 'dd/MM/yyyy') : ''} </p>
<p>Objet: ${mail.subject}</p>
<p>${mail.body}</p>
</p>`
    .replace(/\n+/g, '')
    .trim()
